var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "Loading" }, [
    _c("img", { attrs: { src: _vm.loading, alt: "loading_gif" } }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }